import React, { useState } from 'react';
import { useMutation } from 'react-query';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  useToast,
  Spinner,
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import UserService from '../../services/UserService'; // Import your service
import OTPDialog from './OTPDialog';

const UserRegistrationForm = () => {
  const toast = useToast();
  const [otpDialogOpen, setOtpDialogOpen] = useState(false);
  const [userId, setUserId] = useState(null);
  const { register, handleSubmit, formState: { errors } } = useForm();

  const mutation = useMutation(UserService.registerUser, {
    onSuccess: (data) => {
        console.log(data?.data?.data)
      setUserId(data?.data?.data);
      setOtpDialogOpen(true);
      toast({
        title: "User registered successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    },
    onError: (error) => {
        console.log(error)
      const errorMessage = Array.isArray(error.response.data.errors)
        ? error.response.data.errors.map(err => err.msg).join(', ')
        : error.response.data.message;

      toast({
        title: "Error registering user.",
        description: errorMessage,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  });

  const onSubmit = (data) => {
    mutation.mutate(data);
  };

  return (
    // <Box>
    //   <form onSubmit={handleSubmit(onSubmit)}>
    //     <FormControl isInvalid={errors.name}>
    //       <FormLabel htmlFor="name">Name</FormLabel>
    //       <Input id="name" placeholder="Name" {...register('name', { required: 'Name is required' })} />
    //       <FormErrorMessage>{errors.name && errors.name.message}</FormErrorMessage>
    //     </FormControl>

    //     <FormControl isInvalid={errors.email}>
    //       <FormLabel htmlFor="email">Email</FormLabel>
    //       <Input id="email" placeholder="Email" {...register('email', { required: 'Email is required' })} />
    //       <FormErrorMessage>{errors.email && errors.email.message}</FormErrorMessage>
    //     </FormControl>

    //     <FormControl isInvalid={errors.phoneNumber}>
    //       <FormLabel htmlFor="phoneNumber">Phone Number</FormLabel>
    //       <Input id="phoneNumber" placeholder="Phone Number" {...register('phoneNumber', { required: 'Phone number is required' })} />
    //       <FormErrorMessage>{errors.phoneNumber && errors.phoneNumber.message}</FormErrorMessage>
    //     </FormControl>

    //     <FormControl isInvalid={errors.birthdate}>
    //       <FormLabel htmlFor="birthdate">Birthdate</FormLabel>
    //       <Input type="date" id="birthdate" {...register('birthdate', { required: 'Birthdate is required' })} />
    //       <FormErrorMessage>{errors.birthdate && errors.birthdate.message}</FormErrorMessage>
    //     </FormControl>

    //     <FormControl isInvalid={errors.password}>
    //       <FormLabel htmlFor="password">Password</FormLabel>
    //       <Input type="password" id="password" placeholder="Password" {...register('password', { required: 'Password is required' })} />
    //       <FormErrorMessage>{errors.password && errors.password.message}</FormErrorMessage>
    //     </FormControl>

    //     <FormControl isInvalid={errors.idImage}>
    //       <FormLabel htmlFor="idImage">ID Image</FormLabel>
    //       <Input type="file" id="idImage" {...register('idImage', { required: 'ID image is required' })} />
    //       <FormErrorMessage>{errors.idImage && errors.idImage.message}</FormErrorMessage>
    //     </FormControl>

    //     <Button mt={4} colorScheme="teal" isLoading={mutation.isLoading} type="submit">
    //       Register
    //     </Button>
    //   </form>
    //   {otpDialogOpen && <OTPDialog userId={userId} onClose={() => setOtpDialogOpen(false)} />}
    // </Box>

    <Box>
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl isInvalid={errors.name}>
        <FormLabel htmlFor="name">Name</FormLabel>
        <Input id="name" placeholder="Name" {...register('name', { required: 'Name is required' })} />
        <FormErrorMessage>{errors.name && errors.name.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={errors.email}>
        <FormLabel htmlFor="email">Email</FormLabel>
        <Input id="email" placeholder="Email" {...register('email', { required: 'Email is required' })} />
        <FormErrorMessage>{errors.email && errors.email.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={errors.phoneNumber}>
        <FormLabel htmlFor="phoneNumber">Phone Number</FormLabel>
        <Input id="phoneNumber" placeholder="Phone Number" {...register('phoneNumber', { required: 'Phone number is required' })} />
        <FormErrorMessage>{errors.phoneNumber && errors.phoneNumber.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={errors.birthdate}>
        <FormLabel htmlFor="birthdate">Birthdate</FormLabel>
        <Input type="date" id="birthdate" {...register('birthdate', { required: 'Birthdate is required' })} />
        <FormErrorMessage>{errors.birthdate && errors.birthdate.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={errors.password}>
        <FormLabel htmlFor="password">Password</FormLabel>
        <Input type="password" id="password" placeholder="Password" {...register('password', { required: 'Password is required' })} />
        <FormErrorMessage>{errors.password && errors.password.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={errors.specialist}>
        <FormLabel htmlFor="specialist">Specialist</FormLabel>
        <Input id="specialist" placeholder="Specialist" {...register('specialist')} />
        <FormErrorMessage>{errors.specialist && errors.specialist.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={errors.companyname}>
        <FormLabel htmlFor="companyname">Company Name</FormLabel>
        <Input id="companyname" placeholder="Company Name" {...register('companyname')} />
        <FormErrorMessage>{errors.companyname && errors.companyname.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={errors.address}>
        <FormLabel htmlFor="address">Address</FormLabel>
        <Input id="address" placeholder="Address" {...register('address')} />
        <FormErrorMessage>{errors.address && errors.address.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={errors.idNumber}>
        <FormLabel htmlFor="idNumber">ID Number</FormLabel>
        <Input id="idNumber" placeholder="ID Number" {...register('idNumber')} />
        <FormErrorMessage>{errors.idNumber && errors.idNumber.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={errors.idImage}>
        <FormLabel htmlFor="idImage">ID Image</FormLabel>
        <Input type="file" id="idImage" {...register('idImage', { required: 'ID image is required' })} />
        <FormErrorMessage>{errors.idImage && errors.idImage.message}</FormErrorMessage>
      </FormControl>

      <Button mt={4} colorScheme="teal" isLoading={mutation.isLoading} type="submit">
        Register
      </Button>
    </form>
    {otpDialogOpen && <OTPDialog userId={userId} onClose={() => setOtpDialogOpen(false)} />}
  </Box>
  );
};

export default UserRegistrationForm;
